module.exports = __webpack_public_path__ + "static/media/img-cs-manager@3x.26893650.png";